import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ExpirationUnits } from '../filters/filter';
import {
  preventNonNumericalInput,
  stripLeadingZeros
} from '../earn-rules.utils';

@Component({
  selector: 'app-time-period',
  templateUrl: './time-period.component.html',
  styleUrls: ['./time-period.component.scss'],
  standalone: false
})
export class TimePeriodComponent implements OnInit, OnChanges {
  @Input() fg!: FormGroup;
  @Input() enableHour = false;
  @Input() enableYear = true;
  @Input() isViewOnly = false;
  /** When true (reward period rolling), only hour + day units are allowed. */
  @Input() restrictToHourAndDay = false;
  @Input() expirationUnits: ExpirationUnits[] | undefined;
  selectedUnit!: ExpirationUnits;

  constructor() {}

  ngOnInit(): void {
    this.refreshExpirationUnits();
    this.maybeResetInvalidUnit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      !changes['restrictToHourAndDay'] &&
      !changes['enableHour'] &&
      !changes['enableYear'] &&
      !changes['expirationUnits']
    ) {
      return;
    }
    this.refreshExpirationUnits();
    this.maybeResetInvalidUnit();
  }

  private refreshExpirationUnits(): void {
    if (this.restrictToHourAndDay && !this.isViewOnly) {
      if(this.enableHour){
        this.expirationUnits = [
          ExpirationUnits.HOUR,
          ExpirationUnits.DAY
        ];
      }else{
        this.expirationUnits = [
          ExpirationUnits.DAY
        ];
      }
      return;
    }
    this.expirationUnits = Object.values(ExpirationUnits);
    if (!this.enableHour) {
      this.expirationUnits = this.expirationUnits.filter(
        (ob) => ob !== ExpirationUnits.HOUR
      );
    }
    if (!this.enableYear) {
      this.expirationUnits = this.expirationUnits.filter(
        (ob) => ob !== ExpirationUnits.YEAR
      );
    }
  }

  private maybeResetInvalidUnit(): void {
    if(!this.isViewOnly){
      const unitControl = this.fg?.get('timePeriod')?.get('unit');
      const current = unitControl?.value as ExpirationUnits | null | '';
      if (!unitControl || !current || !this.expirationUnits?.length) {
        return;
      }
      if (!this.expirationUnits.includes(current as ExpirationUnits)) {
        unitControl.patchValue(ExpirationUnits.DAY, { emitEvent: false });
      }
    }
  }

  onUnitsChange() {
    this.fg.get('timePeriod')?.get('value')?.enable();
  }

  preventNonNumericalInput(e: KeyboardEvent) {
    preventNonNumericalInput(e);
  }

  onStripLeadingZeros(event: Event): void {
    stripLeadingZeros(event);
  }
}
